import styled, { keyframes } from "styled-components";
import { colors } from "../../../theme/theme";

const popIn = keyframes`
    0% {
        transform: translateY(0);
        opacity: 0;
    }

    100% {
        transform: translateY(calc(-100% - 2rem));
        opacity: 1;
    }
`;

const positionLookup = {
  right: "flex-end",
  middle: "center",
  left: "flex-start",
};
interface CalloutBoxContainerProps {
  $position: "right" | "middle" | "left";
}

export const CalloutBoxContainer = styled.div<CalloutBoxContainerProps>`
  width: 100%;
  display: flex;
  justify-content: ${({ $position }) => positionLookup[$position]};
  align-items: flex-start;
  padding: 0;

  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 0 1.875rem;
    height: 0;
  }
`;

export const CalloutBoxInner = styled.div`
  width: 100%;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  padding: 1rem 1.5rem;
  background-color: ${colors.white};
  border: 1px solid ${colors["grey-300"]};
  border-radius: 0.5rem;
  box-shadow: ${({ theme }) => theme.shadows.medium};
  transform: translateY(0);
  opacity: 0;

  animation: ${popIn} 0.3s linear 1s 1 forwards;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  a {
    margin-top: 0;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    animation: none;
    opacity: 1;
    max-width: 900px;
    border-radius: 0rem;
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    a {
      text-align: center;
    }
  }
`;
